export default {"src":"/_next/static/media/TEAM.445e496b.svg","height":18,"width":18};